import { jsx as z, Fragment as b, jsxs as A } from "react/jsx-runtime";
import B, { domToReact as R } from "html-react-parser";
import l from "validator/lib/isURL.js";
import { trimBrTagsOnHtml as F } from "../../services/html/index.js";
import T from "sanitize-html";
import { linkInterceptor as L } from "./transformers/linkInterceptor.js";
import { overrideComponentInterceptor as P } from "./transformers/overrideComponentInterceptor.js";
import { youtubeVideoInterceptor as S } from "./transformers/youtubeVideoInterceptor.js";
function W({
  children: w,
  override: s,
  keepOriginalAnchors: C,
  allowedTags: y = [],
  overrides: u,
  clickoutLinkFactory: h,
  isURLOptions: a
}) {
  const H = T(w || "", {
    allowedTags: [...T.defaults.allowedTags, ...y],
    disallowedTagsMode: "discard"
  }), j = (r) => h ? h(r) : r.url, m = (r) => {
    var p, g;
    if (!r.attribs)
      return !1;
    const { name: i, children: c, attribs: x, parent: f } = r, n = r.prev, { data: o } = r, I = !!(c && c.length), d = () => R(c || [], {
      replace: m,
      trim: !0
    });
    if (u) {
      for (const t of u)
        if (t.validation({ domElement: r }))
          return t.transform({ domElement: r });
    }
    if ((p = n == null ? void 0 : n.children) != null && p.length && (n.name === "a" || l(n.children[0].data || "", a))) {
      const t = o ? o.split(" ") : [""], v = t.length ? t[0] : "";
      if (o && v.match("^[,;]+"))
        return t.shift(), /* @__PURE__ */ A(b, { children: [
          " ",
          t.join(" ")
        ] });
    }
    if (i && s && s[i])
      return P({
        name: i,
        override: s,
        renderChildren: d,
        attribs: x,
        haveChildren: I
      });
    const M = l(o || "", a) && (f == null ? void 0 : f.name) !== "a", k = i === "a" || l(o || "", a), e = (g = r.attribs) == null ? void 0 : g.href;
    return !C && k || M ? e && typeof e == "string" && (e.includes("youtube.com/watch") || e.includes("youtube.com/shorts")) ? S({ link: e }) : L({
      domElement: r,
      renderChildren: d,
      clickoutFunction: j
    }) : !1;
  };
  return /* @__PURE__ */ z(b, { children: B(F(H), { replace: m }) });
}
export {
  W as HTMLRenderer,
  L as linkInterceptor,
  P as overrideComponentInterceptor
};
